<div class="form-group">
  <input class="form-control"
         type="datetime-local"
         [value]="formatDateForInput(value)"
         (change)="changeHour($event)"
         [disabled]="disabled"
         [placeholder]="placeholder| translate"/>
</div>
